define([
	"dojo/_base/declare",
	"csi/table/Widget",
	"./_Store",
	"./_TableMixin"
], function(declare,Table,_Store,_TableMixin) {

	var	_ViewStore = declare(_Store, {
		typeSection: "View",
		
		_getResource: function(/*Node*/node, /*LocaleResolver*/lr) {
			// summary: get resource for key from resolver
			return lr.getTypeView(node.Type, node.Id);
		}
	});

	return declare([Table,_TableMixin], {
		storeClass: _ViewStore
	});
});